import React from 'react'

import { AppTheme, AppThemeOptions, createAppTheme } from './themeAugmentation'

import { ApertoLogo, IncubetaLogo, JellyfishLogo, Percept } from '../components/Logos'

import { basePerceptThemeOptions } from './basePerceptThemeOptions'

import {
  baseDarkPerceptThemeOptions,
  baseLightPerceptThemeOptions,
} from './perceptAppThemeV2'

import { merge } from 'lodash-es'

import { AppBranding, ThemeType } from '@percept/types'

import { incubetaDarkThemeOptions, incubetaLightThemeOptions } from './incubetaAppTheme'
import { apertoDarkThemeOptions, apertoLightThemeOptions } from './apertoAppTheme'


type BrandedAppThemeOptions = (
  Pick<
    AppThemeOptions, 'branding'
  > &
  Partial<
    RecursiveOptional<
      Omit<
        AppThemeOptions, 'branding'
      >
    >
  >
)


type RecursiveOptional<T extends object> = {
  [K in keyof T]: (T[K] extends object ? (Partial<T[K]> | undefined) : T[K] | undefined)
}


export const makeBrandedAppTheme = (
  options: BrandedAppThemeOptions,
  themeOptions?: Omit<AppThemeOptions, 'branding'>
): AppTheme => (
  createAppTheme(merge({}, basePerceptThemeOptions, themeOptions || {}, options))
)

const brandingConfigs: Record<'PERCEPT' | 'JELLYFISH' | 'INCUBETA' | 'APERTO', BrandedAppThemeOptions> = {
  PERCEPT: {
    branding: {
      label: 'Percept',
      LogoComponent: Percept,
    }
  },
  JELLYFISH: {
    branding: {
      label: 'Jellyfish',
      // eslint-disable-next-line
      LogoComponent: (props) => (
        <JellyfishLogo
          {...props}
          size={20}
          units='px' />
      ),
    },
  },
  INCUBETA: {
    branding: {
      label: 'Incubeta',
      // eslint-disable-next-line
      LogoComponent: (props) => (
        <IncubetaLogo
          {...props}
          size={22}
          units='px' />
      )
    }
  },
  APERTO: {
    branding: {
      label: 'Aperto',
      LogoComponent: ApertoLogo,
    }
  }
}

type TypedThemeOptions = Record<ThemeType, AppTheme>

const jellyfishTypedThemes: TypedThemeOptions = {
  DARK: makeBrandedAppTheme(brandingConfigs.JELLYFISH, baseDarkPerceptThemeOptions),
  LIGHT: makeBrandedAppTheme(brandingConfigs.JELLYFISH, baseLightPerceptThemeOptions),
}

export const brandedTypedThemes: (
  Record<'PERCEPT', Record<ThemeType, AppTheme>> &
  Partial<Record<AppBranding, Record<ThemeType, AppTheme>>>
) = {
  PERCEPT: {
    DARK: makeBrandedAppTheme(brandingConfigs.PERCEPT, baseDarkPerceptThemeOptions),
    LIGHT: makeBrandedAppTheme(brandingConfigs.PERCEPT, baseLightPerceptThemeOptions),
  },
  BRANDTECH: jellyfishTypedThemes,
  JELLYFISH: jellyfishTypedThemes,
  INCUBETA: {
    DARK: makeBrandedAppTheme(brandingConfigs.INCUBETA, incubetaDarkThemeOptions),
    LIGHT: makeBrandedAppTheme(brandingConfigs.INCUBETA, incubetaLightThemeOptions),
  },
  APERTO: {
    DARK: makeBrandedAppTheme(brandingConfigs.APERTO, apertoDarkThemeOptions),
    LIGHT: makeBrandedAppTheme(brandingConfigs.APERTO, apertoLightThemeOptions),
  },
}
